// src/Header.js
import React from 'react';
import gameLogo from '../assets/FusionTales.png'; // Path to your game logo

const HeaderFusionTales  = () => {
  return (
    <header style={{
      backgroundColor: '#002B32',
      padding: '10px',
      textAlign: 'center',
      display: 'flex', // Enable flexbox
      alignItems: 'center', // Vertically center the items
      justifyContent: 'center' // Horizontally center the items
    }}>
      <img src={gameLogo} alt="Game Logo" style={{ height: '50px', marginRight: '10px' }} />
      <h2 style={{ color: 'white', margin: 0 }}>Fusion Tales</h2>
    </header>
  );
};

export default HeaderFusionTales ;